export default {
  LIST(state, data) {
    state.applyDocuments = data
  },
  GET(state, data) {
    state.applyDocument = data
  },
  HISTORY(state, data) {
    state.applyDocumentHistory = data
  },
  UPDATE(state, value) {
    state.applyDocument = { ...value }
  },
  SET(state, value) {
    state.applyDocument = value
  },
  ORGANIZATIONS(state, data) {
    state.organizations = data
  },
  DIRECTIONS(state, data) {
    state.directions = data
  },
  FRESH(state) {
    state.applyDocumentHistory = []
    state.applyDocument = {
      id: null,
      dc_type: null,
      edu_lang: null,
      status: null,
      reject_info: '',
      organization: null,
      direction: null,
      scientific_works: {},
    }
  },
}
